import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { environment } from '../../../../../../../../environments/environment';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite
} from '../../../../../../../openapi';

@Injectable()
export class OpinionOnIssuingADecisionApplicationDataForm extends AppForm {

  public municipalities: string[] = [
    'Gmina Miasta Dębica',
    'Brzostek',
    'Pilzno',
    'Czarna',
    'Gmina Dębica',
    'Jodłowa',
    'Żyraków',
    'Inna'
  ];

  constructor() {
    super({
      office: new FormControl({ value: environment.applicationSubmittedTo, disabled: true }, { nonNullable: true }),
      documentReceiptMethod: new FormControl('', { validators: [Validators.required], nonNullable: true }),
      municipality: new FormControl('', { validators: [Validators.required], nonNullable: true }),
      investmentName: new FormControl(
        null,
        {
          validators: [
            Validators.required,
            Validators.maxLength(255)
          ]
        }
      ),
      objectName: new FormControl(
        null,
        {
          validators: [
            Validators.required,
            Validators.maxLength(255)
          ]
        }
      )
    });
  }

  public get municipality(): FormControl {
    return this.get('municipality') as FormControl;
  }

  public municipalityChange(v: string): void {
    if (v !== 'Inna') {
      this.removeControl('otherMunicipality');
    } else {
      this.addControl('otherMunicipality', new FormControl(null, [Validators.required, Validators.maxLength(255)]));
    }
  }

  public get otherMunicipality(): FormControl | null {
    return this.get('otherMunicipality') as FormControl | null;
  }

  public get documentReceiptMethod(): FormControl {
    return this.get('documentReceiptMethod') as FormControl;
  }

  public get ePuapAddress(): FormControl | null {
    return this.get('ePuapAddress') as FormControl | null;
  }

  public get eDeliveryAddress(): FormControl | null {
    return this.get('eDeliveryAddress') as FormControl | null;
  }

  public documentReceiptMethodChange(v: string): void {
    if (v === '4d536cdd-dc3a-42f9-bf89-342e5cc0c885') {
      this.addControl(
        'ePuapAddress',
        new FormControl('', [Validators.required, Validators.maxLength(255)])
      );
    } else {
      this.removeControl('ePuapAddress');
    }
    if (v === '6bef93e4-f125-49f2-ab12-11ddc5e1e8a2') {
      this.addControl('eDeliveryAddress', new FormControl('', [Validators.required, Validators.maxLength(255)]));
    } else {
      this.removeControl('eDeliveryAddress');
    }
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead) {
    super.patchFormValues(value);

    if (this.municipalities.includes(value?.applicationSubject || '')) {
      this.municipality.setValue(value?.applicationSubject);
      this.municipalityChange(value?.applicationSubject || '');
    } else {
      this.municipality.setValue('Inna');
      this.municipalityChange('Inna');
    }

    this.otherMunicipality?.setValue(value?.applicationSubject);

    this.documentReceiptMethod.setValue(value.documentReceiptMethod?.id);
    this.documentReceiptMethodChange(value?.documentReceiptMethod?.id || '');

    this.ePuapAddress?.setValue(value?.ePuapAddress);
    this.eDeliveryAddress?.setValue(value?.eDeliveryAddress);
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      applicationSubject: this.otherMunicipality?.value || this.municipality.value,
      documentReceiptMethod: this.documentReceiptMethod.value,
      ePuapAddress: this.ePuapAddress?.value || null,
      eDeliveryAddress: this.eDeliveryAddress?.value || null,
      investmentName: this.value.investmentName,
      objectName: this.value.objectName
    };
  }
}
